import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  ButtonsContainer,
  TitleStyled,
  ButtonStyled,
  TextFieldStyled,
  ButtonStyledCancel,
  StyledContainerValue
} from './transferLocationBarStyles';
import Strings from '../../../i18n';
import { TransferLocationProps } from './transferLocationProps';
import {
  useTransferLocMutation,
  useTransferOrgMutation
} from '../../../services/device/deviceService';
import { colors } from '../../../constants/colors';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';

export const TransferLocationBar = ({
  reloadTable,
  selectedLocations,
  selectedOrganization,
  setOpenRightSideBar
}: TransferLocationProps) => {
  const [fieldValue, setFieldValue] = useState('');

  const [
    transferOrganization,
    {
      isLoading,
      isSuccess: isSuccessTransferOrganization,
      isError: isErrorTransferOrganization,
      error: errorTransferOrganization
    }
  ] = useTransferOrgMutation();
  const [
    transferLocation,
    {
      isLoading: isLoadingTransferLoc,
      isSuccess: isSuccessTransferLoc,
      isError: isErrorTransferLoc,
      error: errorTransferLoc
    }
  ] = useTransferLocMutation();

  useEffect(() => {
    if (isSuccessTransferOrganization) {
      reloadTable();
      toast.success(Strings.organizations.successTransferOrg);
      setOpenRightSideBar(false);
    }
  }, [isSuccessTransferOrganization]);

  useEffect(() => {
    if (isSuccessTransferLoc) {
      reloadTable();
      toast.success(Strings.locations.successTransferLocation);
      setOpenRightSideBar(false);
    }
  }, [isSuccessTransferLoc]);

  const sendInfo = () => {
    const trimmedEmail = fieldValue.trim();
    const locationIds = selectedLocations;
    const organizationIds = selectedOrganization?.map(
      (element) => element.organizationId ?? null
    );

    if (locationIds) {
      transferLocation({
        email: trimmedEmail,
        locationIds
      });
    }

    if (organizationIds) {
      transferOrganization({
        email: trimmedEmail,
        organizationIds
      });
    }
  };

  useEffect(() => {
    if (isErrorTransferOrganization) {
      toast.error(
        `${
          (errorTransferOrganization as { data: { message: string } }).data
            .message
        }`
      );
    }
  }, [isErrorTransferOrganization]);

  useEffect(() => {
    if (isErrorTransferLoc) {
      toast.error(
        `${(errorTransferLoc as { data: { message: string } }).data.message}`
      );
    }
  }, [isErrorTransferLoc]);
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.locations.transferOwnership}
        </StyledTitleSideBar>
        <StyledContainerValue>
          <Typography
            fontSize={13}
            marginTop={1}
            marginLeft={0}
            color={colors.blue}
          >
            {Strings.locations.email}
          </Typography>
          <TextFieldStyled
            onChange={(
              e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setFieldValue(e.target.value.toString())}
            fullWidth
            variant="outlined"
            size="small"
          />
        </StyledContainerValue>
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={!fieldValue || isLoading || isLoadingTransferLoc}
          onClick={sendInfo}
        >
          {isLoading || isLoadingTransferLoc
            ? Strings.common.loading
            : Strings.common.save}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
